import { FieldsOptions } from '@sim/form';
import { FilterFieldsOptions } from '@ui/ui.module';

import { iccdDateValidator } from '@sim/form/validators';

import { CardPaper, CardPaperMeta, ICCDMeta } from '@atmi/core/models/cards/card';
import { RelationDMeta, RelationFMeta, RelationMIMeta, RelationOAMeta, RelationSMeta } from '@atmi/core/models/cards/relation';

export interface MIS {
  /** Unità */
  MISU: string;
  /** Altezza */
  MISA: string;
  /** Larghezza */
  MISL: string;
  /** Diametro */
  MISD: string;
  /** Validità */
  MIST: string;
  /** Varie */
  MISV: string[];
  /**  Mancanza */
  MISR: string;
}

// tslint:disable-next-line:no-empty-interface
export interface CardD extends CardPaper {
  /** Misure */
  MIS: MIS;
}

export interface CardDFilter {
  codiceUnico?: string;
  ['SGT.SGTT']?: string;
  MTC?: string;
}

export const MISMeta: FieldsOptions<MIS> = {
  MISA: { value: '' },
  MISL: { value: '' },
  MISR: { value: '' },
  MIST: { value: '', validators: [iccdDateValidator()] },
  MISU: { value: '' },
  MISV: { value: [], type: 'array' },
};

export const CardDMeta: FieldsOptions<any> = {
  ...CardPaperMeta,
  AUT: { ...ICCDMeta.AUT, value: [{ AUTN: 'Igor Mitoraj', AUTA: 'Oederan, 26 marzo 1944 – Parigi, 6 ottobre 2014' }] },
  MIS: { type: 'object', controls: MISMeta, value: {}, additionalInfo: { label: 'Misure' } },
  TSK: { ...ICCDMeta.TSK, value: 'D' },
  relazioniBeniD: { type: 'array', controls: RelationDMeta, value: [] },
  relazioniBeniF: { type: 'array', controls: RelationFMeta, value: [] },
  relazioniBeniMI: { type: 'array', controls: RelationMIMeta, value: [] },
  relazioniBeniOA: { type: 'array', controls: RelationOAMeta, value: [] },
  relazioniBeniS: { type: 'array', controls: RelationSMeta, value: [] },
};

export const CardDFiltersMeta: FilterFieldsOptions<CardDFilter> = {
  MTC: { operator: 'begins_with' },
  codiceUnico: { operator: 'begins_with' },
  ['SGT.SGTT']: { operator: 'begins_with' },
};
